export const overlayClasses = 'fixed inset-0 overlay-background animate-fade-in'
export const overlay = <div className={overlayClasses} />
